import { render, staticRenderFns } from "./folders-vessels-option-cash-flow.vue?vue&type=template&id=5520946e&scoped=true"
import script from "./folders-vessels-option-cash-flow.vue?vue&type=script&lang=js"
export * from "./folders-vessels-option-cash-flow.vue?vue&type=script&lang=js"
import style0 from "./folders-vessels-option-cash-flow.vue?vue&type=style&index=0&id=5520946e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520946e",
  null
  
)

export default component.exports